import React from "react";

import { IBaseComponent } from "../models/formFields";
import { FormFieldWrapper } from "./FormFieldWrapper";

export const NonFieldErrors = (props: IBaseComponent): React.ReactNode => {
    return <FormFieldWrapper {...props} />;
};
